// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__2BBno","active":"Uploader_active__2eX5E"};